module.exports = __webpack_public_path__ + "img/merchantRate.ab5fd8b5.png";